'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isFinite = require('lodash/isFinite');

var _isFinite2 = _interopRequireDefault(_isFinite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ControlRoomUtils = function () {
  function ControlRoomUtils() {
    _classCallCheck(this, ControlRoomUtils);
  }

  _createClass(ControlRoomUtils, null, [{
    key: 'validateParentData',
    value: function validateParentData(height, width, top, left) {
      if (!(0, _isFinite2.default)(height)) {
        return false;
      }

      if (!(0, _isFinite2.default)(width)) {
        return false;
      }

      if (!(0, _isFinite2.default)(top)) {
        return false;
      }

      if (!(0, _isFinite2.default)(left)) {
        return false;
      }

      return true;
    }
  }, {
    key: 'toProportion',
    value: function toProportion() {
      var childData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var parentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var pHeight = parseInt(parentData.height, 10);
      var pWidth = parseInt(parentData.width, 10);
      var pLeft = parseInt(parentData.left, 10);
      var pTop = parseInt(parentData.top, 10);

      var DEFAULT_WIDTH = 700;
      var DEFAULT_HEIGHT = 300;
      var DEFAULT_TOP = 100;
      var DEFAULT_LEFT = 100;

      var isValidParentData = ControlRoomUtils.validateParentData(pHeight, pWidth, pTop, pLeft);

      var _childData$dimensions = childData.dimensions;
      _childData$dimensions = _childData$dimensions === undefined ? {} : _childData$dimensions;
      var _childData$dimensions2 = _childData$dimensions.height,
          height = _childData$dimensions2 === undefined ? DEFAULT_HEIGHT : _childData$dimensions2,
          _childData$dimensions3 = _childData$dimensions.width,
          width = _childData$dimensions3 === undefined ? DEFAULT_WIDTH : _childData$dimensions3,
          _childData$coordinate = childData.coordinates;
      _childData$coordinate = _childData$coordinate === undefined ? {} : _childData$coordinate;
      var _childData$coordinate2 = _childData$coordinate.top,
          top = _childData$coordinate2 === undefined ? DEFAULT_TOP : _childData$coordinate2,
          _childData$coordinate3 = _childData$coordinate.left,
          left = _childData$coordinate3 === undefined ? DEFAULT_LEFT : _childData$coordinate3;


      var adjustedChildData = {
        dimensions: {
          height: (0, _isFinite2.default)(height) ? height : DEFAULT_HEIGHT,
          width: (0, _isFinite2.default)(width) ? width : DEFAULT_WIDTH
        },
        coordinates: {
          top: (0, _isFinite2.default)(top) ? top : DEFAULT_TOP,
          left: (0, _isFinite2.default)(left) ? left : DEFAULT_LEFT
        }
      };

      if (!isValidParentData) {
        console.error('Invalid parent data: ' + parentData);
      }

      var percentageHeight = adjustedChildData.dimensions.height / pHeight;
      var percentageWidth = adjustedChildData.dimensions.width / pWidth;

      percentageHeight = percentageHeight > 1 ? 1 : percentageHeight;
      percentageWidth = percentageWidth > 1 ? 1 : percentageWidth;

      percentageHeight = percentageHeight < 0 ? 0 : percentageHeight;
      percentageWidth = percentageWidth < 0 ? 0 : percentageWidth;

      var percentageLeft = (adjustedChildData.coordinates.left - pLeft) / pWidth;
      var percentageTop = (adjustedChildData.coordinates.top - pTop) / pHeight;

      percentageLeft = percentageLeft > 1 ? 1 : percentageLeft;
      percentageTop = percentageTop > 1 ? 1 : percentageTop;

      percentageLeft = percentageLeft < 0 ? 0 : percentageLeft;
      percentageTop = percentageTop < 0 ? 0 : percentageTop;

      return {
        coordinates: {
          left: percentageLeft,
          top: percentageTop
        },
        dimensions: {
          width: percentageWidth,
          height: percentageHeight
        }
      };
    }
  }, {
    key: 'fromProportion',
    value: function fromProportion() {
      var childData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var parentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var pHeight = parseInt(parentData.height, 10);
      var pWidth = parseInt(parentData.width, 10);
      var pLeft = parseInt(parentData.left, 10);
      var pTop = parseInt(parentData.top, 10);

      var DEFAULT_WIDTH = 0.5;
      var DEFAULT_HEIGHT = 0.5;
      var DEFAULT_TOP = 0.25;
      var DEFAULT_LEFT = 0.25;

      var isValidParentData = ControlRoomUtils.validateParentData(pHeight, pWidth, pTop, pLeft);

      var _childData$dimensions4 = childData.dimensions;
      _childData$dimensions4 = _childData$dimensions4 === undefined ? {} : _childData$dimensions4;
      var _childData$dimensions5 = _childData$dimensions4.height,
          height = _childData$dimensions5 === undefined ? DEFAULT_HEIGHT : _childData$dimensions5,
          _childData$dimensions6 = _childData$dimensions4.width,
          width = _childData$dimensions6 === undefined ? DEFAULT_WIDTH : _childData$dimensions6,
          _childData$coordinate4 = childData.coordinates;
      _childData$coordinate4 = _childData$coordinate4 === undefined ? {} : _childData$coordinate4;
      var _childData$coordinate5 = _childData$coordinate4.top,
          top = _childData$coordinate5 === undefined ? DEFAULT_TOP : _childData$coordinate5,
          _childData$coordinate6 = _childData$coordinate4.left,
          left = _childData$coordinate6 === undefined ? DEFAULT_LEFT : _childData$coordinate6;


      var adjustedChildData = {
        dimensions: {
          height: (0, _isFinite2.default)(height) ? height : DEFAULT_HEIGHT,
          width: (0, _isFinite2.default)(width) ? width : DEFAULT_WIDTH
        },
        coordinates: {
          top: (0, _isFinite2.default)(top) ? top : DEFAULT_TOP,
          left: (0, _isFinite2.default)(left) ? left : DEFAULT_LEFT
        }
      };

      if (!isValidParentData) {
        console.error('Invalid parent data: ' + parentData);
      }

      var pxHeight = adjustedChildData.dimensions.height * pHeight;
      var pxWidth = adjustedChildData.dimensions.width * pWidth;

      var pxTop = adjustedChildData.coordinates.top * pHeight + pTop;
      var pxLeft = adjustedChildData.coordinates.left * pWidth + pLeft;

      return {
        coordinates: {
          left: pxLeft,
          top: pxTop
        },
        dimensions: {
          width: pxWidth,
          height: pxHeight
        }
      };
    }
  }]);

  return ControlRoomUtils;
}();

ControlRoomUtils.WORKSPACE_ASPECT_RATIO = 1.95;

ControlRoomUtils.reorderArray = function (array, moving, moveTo) {
  var movingKey = array.indexOf(moving);
  var movingTo = array.indexOf(moveTo);

  // remove the element we're moving from the array
  var movingEntry = array.splice(movingKey, 1)[0];
  array.splice(movingTo, 0, movingEntry);

  return array;
};

exports.default = ControlRoomUtils;